import React, { useState,forwardRef } from "react";
import {
  Col,
  Empty,
  Popover,
  Row,
  Space,
  Typography,
  Tooltip,
  Button,
  message,
  Drawer,
} from "antd";
import { StarOutlined, FireOutlined } from "@ant-design/icons";
import Sc from "@/assets/images/sc.svg";
import Qxsc from "@/assets/images/qxsc.svg";
import Rd from "@/assets/images/rd.svg";
import API from "@/api";
import axios from "axios";
import moment from "moment";
import DrawerDetail from "./drawerDetail";

function CardDetail(props,ref) {
  const { data, onClick, style, mobile = false } = props;
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

    if (ref) {
    ref.current = {
      closeModel: () => {
        setOpen(false)
      },
     
    };
  }
    
  return (
    <>
      <Row gutter={[32, 32]} className="cardDetail" style={style}>
        {data?.length ? (
          data?.map((item, index) => {
            return mobile ? (
              <div
                className="m-znt-space"
                key={index}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="listItem"
                  key={index}
                  onClick={() => {
                    setOpen(true);
                    setSelectedRow(item);
                  }}
                >
                  <div className="iconContent">
                    <div className="icon">
                      <img src={item?.icon} />
                    </div>
                    <div className="wrapContent">
                      <div className="titleAndContent">
                        <div className="cardTitle">{item.label}</div>
                        <Tooltip content={item?.summary ?? ""}>
                          <Typography.Paragraph
                            ellipsis={{ rows: 2 }}
                            style={{
                              color: "rgb(51, 51, 51)",
                              fontSize: 13,
                              opacity: 0.6,
                              fontWeight: 400,
                              fontFamily: "思源黑体 CN",
                            }}
                          >
                            {item?.summary ?? ""}
                          </Typography.Paragraph>
                        </Tooltip>
                      </div>
                    </div>
                  </div>

                  <div className="agreeAndCollect">
                    <div className="icons zdIcons">
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <div>
                            <span>
                              {item.favorite ? (
                                <img
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    cursor: "pointer",
                                  }}
                                  src={Sc}
                                  alt=" "
                                  onClick={() => {
                                    axios
                                      .get(
                                        API.cancelFavorite +
                                          `?zntId=${item.zntId}`
                                      )
                                      .then(() => {
                                        scRefresh();
                                        message.success("取消成功");
                                      });
                                  }}
                                />
                              ) : (
                                <img
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    cursor: "pointer",
                                  }}
                                  src={Qxsc}
                                  alt=" "
                                  onClick={() => {
                                    axios
                                      .get(
                                        API.addFavorite + `?zntId=${item.zntId}`
                                      )
                                      .then(() => {
                                        scRefresh();
                                        message.success("收藏成功");
                                      });
                                  }}
                                />
                              )}
                            </span>
                            <span
                              style={{
                                lineHeight: "25px",
                                paddingLeft: "4px",
                              }}
                            >
                              {item.favoriteNum}
                            </span>
                          </div>
                        </Col>
                        <Col span={8}>
                          <div>
                            <span>
                              <img
                                style={{
                                  width: "25px",
                                  height: "20px",
                                }}
                                src={Rd}
                                alt=" "
                              />
                            </span>

                            <span>{formatDialogCount(item.qaNum)}</span>
                          </div>
                        </Col>
                        <Col span={8}>
                          <div>
                            {item.owner?.name ? (
                              <Tooltip title={item.owner?.name}>{`@${
                                item.owner?.name.length > 5
                                  ? item.owner?.name.slice(0, 3) + "..."
                                  : item.owner?.name
                              }`}</Tooltip>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <Col
                className="znt-col"
                xs={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                key={index}
              >
                <div className="listItem" key={index}>
                  <div
                    className="iconContent"
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      // onClick?.(item);
                      setOpen(true);
                      setSelectedRow(item);
                    }}
                  >
                    <div className="icon">
                      <img src={item?.icon} />
                    </div>
                    <div
                      className="wrapContent"
                      style={{
                        width: "calc(100% - 75px)",
                      }}
                    >
                      <div className="titleAndContent">
                        <div
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            padding: "12px 0",
                          }}
                        >
                          <Tooltip title={item.label}>{item.label}</Tooltip>
                        </div>
                        <div
                          style={{
                            color: "#00000072",
                          }}
                        >
                          所有者：{item.user}
                        </div>
                        <div
                          style={{
                            color: "#00000072",
                            padding: "4px 0",
                          }}
                        >
                          发布时间：{moment(item.sj).format("YYYY-MM-DD")}
                        </div>
                        <div
                          style={{
                            color: "#00000072",
                            textAlign: "right",
                          }}
                        >
                          {item.source}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            );
          })
        ) : (
          <Col span={24}>
            <div style={{ textAlign: "center", paddingTop: "20px" }}>
              <Typography.Text style={{ textAlign: "center" }} type="secondary">
                <Empty style={{ height: 50 }} description={"暂无数据"}></Empty>
              </Typography.Text>
            </div>
          </Col>
        )}
        <div></div>
      </Row>
      <Drawer
        title=""
        open={open}
        onClose={() => {
          setOpen(false);
          setSelectedRow({})
        }}
        width={"65%"}
        footer={
          <>
            <Space>
              <Button
                onClick={() => {
                  setOpen(false);
                  setSelectedRow({})
                }}
              >
                关闭
              </Button>
            </Space>
          </>
        }
      >
        <DrawerDetail selectedRow={selectedRow} onClick={onClick} />
      </Drawer>
    </>
  );
}

export default forwardRef(CardDetail);
